import { render } from "./ModalComentarios.vue?vue&type=template&id=312ed9de&scoped=true&ts=true"
import script from "./ModalComentarios.vue?vue&type=script&lang=ts"
export * from "./ModalComentarios.vue?vue&type=script&lang=ts"

import "./ModalComentarios.vue?vue&type=style&index=0&id=312ed9de&scoped=true&lang=scss"

import exportComponent from "C:\\AgentesAzure\\SVRAPQAHIR01\\vsts-agent-win-x64-4.261.0\\_work\\18\\s\\hircasa-srp-webapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-312ed9de"]])

export default __exports__